var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_801_33135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.625 9.42877L8.99998 14.9998L3.37498 9.42877C3.00396 9.06773 2.71171 8.63378 2.51664 8.15424C2.32157 7.67471 2.2279 7.15998 2.24153 6.64247C2.25517 6.12495 2.3758 5.61587 2.59585 5.14727C2.8159 4.67867 3.13058 4.26071 3.5201 3.9197C3.90961 3.5787 4.36551 3.32203 4.85909 3.16588C5.35267 3.00972 5.87324 2.95745 6.38801 3.01237C6.90278 3.06728 7.40061 3.22818 7.85014 3.48495C8.29967 3.74171 8.69117 4.08877 8.99998 4.50427C9.31013 4.09178 9.70208 3.74776 10.1513 3.49372C10.6005 3.23968 11.0974 3.0811 11.6107 3.02791C12.124 2.97471 12.6428 3.02804 13.1346 3.18456C13.6263 3.34108 14.0805 3.59742 14.4686 3.93754C14.8568 4.27766 15.1706 4.69423 15.3903 5.16119C15.61 5.62814 15.731 6.13543 15.7457 6.6513C15.7604 7.16717 15.6684 7.68051 15.4756 8.1592C15.2827 8.6379 14.9932 9.07163 14.625 9.43327",
    stroke: "#FF5B5B",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_801_33135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart);
export default __webpack_public_path__ + "static/media/icon-heart.d889f0235b122070ff45b3fe7a65a838.svg";
export { ForwardRef as ReactComponent };